import Login from 'components/Login';
import CampaignsList from './Campaigns/List';
import CampaignsShow from './Campaigns/Show';

import QuoteRequestList from './QuoteRequest/List';
import QuoteRequestShow from './QuoteRequest/Show';
import LeadsController from './Resales/LeadsController';

import ResalesList from './Resales/List';
import ResalesShow from './Resales/Show';
import Attendance from './Resales/Attendance';
import Brands from './Resales/Brands';
import LeadHistory from './Resales/LeadHistory';

import Charts from './Charts';
import Reports from './Reports';
import ReportsError from './ReportsError';

const PublicRoutes = [
    { pathname: '/sumo/login', component: Login, exact: true },
    { pathname: '/', component: Login, exact: true },
    { pathname: '/sumo/quote-request', component: QuoteRequestList, exact: true },
    { pathname: 'sumo/quote-request/show/:id', component: QuoteRequestShow, exact: true },
    { pathname: '/sumo/leads-controller', component: LeadsController, exact: true },
    
    { pathname: '/sumo/resales', component: ResalesList, exact: true },
    { pathname: '/sumo/resales/show', component: ResalesShow, exact: true },
    { pathname: '/sumo/resales/attendance', component: Attendance, exact: true },
    { pathname: '/sumo/resales/brands', component: Brands, exact: true },
    { pathname: '/sumo/resales/lead-history', component: LeadHistory, exact: true },

    { pathname: '/sumo/campaigns', component: CampaignsList, exact: true },
    { pathname: '/sumo/campaigns/show', component: CampaignsShow, exact: true },

    { pathname: '/sumo/charts', component: Charts, exact: true },

    { pathname: '/sumo/report-leads-by-status', component: Reports, exact: true},
    { pathname: '/sumo/report-leads-error', component: ReportsError, exact: true}
];

const PrivateRoutes = [

]

export { PublicRoutes, PrivateRoutes };